const APPOINTMENTS_MAX_RETRIES = 3
const APPOINTMENTS_BASE_DELAY_MS = 1000
const APPOINTMENTS_MAX_DELAY_MS = 8000

// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
export const getAppointmentsRetryDelay = (retryCount, error) => {
  const safeRetryCount = retryCount ?? 0
  const delay = APPOINTMENTS_BASE_DELAY_MS * 2 ** safeRetryCount
  return Math.min(delay, APPOINTMENTS_MAX_DELAY_MS)
}

export const APPOINTMENTS_RETRY = {
  retry: APPOINTMENTS_MAX_RETRIES,
  retryDelay: getAppointmentsRetryDelay
}
